import {ReactComponent as Calender} from '../../../../../assets/icons/calender.svg'; // Import your SVG icon
import "../../../../../css/CashflowModeller2/Buttons/Calender.css"; // Import your CSS file

/**
 * Renders a calendar icon component with optional disabled styling.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} [props.isDisabled=false] - If true, applies a disabled style to the icon.
 * @returns {JSX.Element} The rendered calendar icon component.
 */
const CalenderIcon = ({isDisabled = false}) => {
    return (
    <>
        <div className={`calender-icon ${isDisabled ? "disabled" : ""}`}>
            <Calender
            />
            </div>
     
       
            </>
      
    );
};

export default CalenderIcon;